const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

const conditions = {
  'non-functioning': 'nonFunctioning',
  'poor': 'poor',
  'fair': 'fair',
  'good': 'good',
  'very-good': 'veryGood',
  'excellent': 'excellent',
  'mint': 'mint',
  'mint-inventory': 'mintInventory',
  'b-stock': 'bStock',
  'brand-new': 'brandNew',
};

class ConditionExplanation extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      condition: props.condition,
    };
  }

  componentDidMount() {
    this.bindSelectChange();
  }

  bindSelectChange() {
    $(document).on('change', this.props.selectField, () => this.setCondition());
  }

  setCondition() {
    const condition = $(this.props.selectField).val();
    this.setState({ condition: condition });
  }

  explanationMessage(selectedCondition) {
    const props = {
      span_open: '<span>',
      span_close: '</span>',
      no_break: '&nbsp;',
    };
    const msg = I18n.t(`js.listingForm.conditionExplanation.${selectedCondition}`, props);

    return { __html: msg };
  }

  conditionClassNames() {
    return (
      classNames(
        'condition-explanation',
        `condition-explanation--${this.state.condition}`
      )
    );
  }

  render() {
    const selectedCondition = conditions[this.state.condition];

    if (selectedCondition) {
      return (
        <div className={this.conditionClassNames()} dangerouslySetInnerHTML={this.explanationMessage(selectedCondition)} />
      );
    }

    return null;
  }
}

ConditionExplanation.propTypes = {
  selectField: PropTypes.string.isRequired,
  condition: PropTypes.string,
};

module.exports = ConditionExplanation;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/condition_explanation.jsx